import React from 'react';
import {Container} from './Styled'
import ComponentSection from './ComponentSection/ComponentSection';
type ToolBoxProps = {
};

export const ToolBox: React.FunctionComponent<ToolBoxProps> = (props) => {
  return (
   <Container>
       <ComponentSection/>
   </Container>
  );
}

export default ToolBox;